import ReportSubsection from "@app/analytics/components/reports/ReportSubsection";
import useMeetingReportHighlights from "@app/analytics/MeetingReport/hooks/useMeetingReportHighlights";
import useTranscript from "@app/analytics/MeetingReport/hooks/useTranscript";
import MeetingReportChapters from "@app/analytics/MeetingReport/MeetingReportChapters";
import MeetingReportHighlights from "@app/analytics/MeetingReport/MeetingReportHighlights";
import type { RecapSection } from "@app/analytics/MeetingReport/types";

import RecapNotesSection, { RecapNotesSectionProps } from "./RecapNotesSection";
import RecapTranscriptSection from "./RecapTranscriptSection";

const HighlightsSection = () => {
  const { highlights } = useMeetingReportHighlights();

  return (
    <ReportSubsection id="highlights">
      <MeetingReportHighlights highlights={highlights} />
    </ReportSubsection>
  );
};

const ChaptersSection = () => {
  const {
    summary: { chapters },
  } = useTranscript();

  return (
    <ReportSubsection id="chapters">
      <MeetingReportChapters chapters={chapters} />
    </ReportSubsection>
  );
};

type TabbedRecapContentProps = RecapNotesSectionProps & {
  selectedSection: RecapSection;
};

const TabbedRecapContent = ({
  chartProps,
  selectedSection,
  showCharts,
}: TabbedRecapContentProps) => {
  switch (selectedSection) {
    case "transcript":
      return <RecapTranscriptSection asTab />;
    case "highlights":
      return <HighlightsSection />;
    case "chapters":
      return <ChaptersSection />;
    case "notes":
    default:
      return (
        <RecapNotesSection
          asTab
          chartProps={chartProps}
          showCharts={showCharts}
        />
      );
  }
};

export default TabbedRecapContent;
